module.exports = __webpack_public_path__ + "static/media/Donphan_gaussian2.38ba1773.png";